import { ClientConfig } from 'services/clientConfig';
import { isServer } from 'utils/helpers/browser';

const ALLOWED_DOMAINS: Readonly<string[]> = [
  'www.zmyle.de',
  'www-ui.zmyledemo.de',
  'www-ui.zmyledev.de',
];

interface ZmyleCookie {
  consents: {
    marketing: string[];
  };
}

export const isGoogleAdsEnabled = (zmyleCookie: ZmyleCookie): boolean => {
  if (isServer()) return false;

  const clientConfig = ClientConfig.getInstance().getConfig();

  const isGoogleTagManagerConfigured = Boolean(clientConfig.googleTagManagerId);
  const isAllowedDomain = ALLOWED_DOMAINS.includes(window.location.hostname);
  const isCookieEnabled =
    zmyleCookie.consents.marketing.includes('google-analytics');

  return isGoogleTagManagerConfigured && isAllowedDomain && isCookieEnabled;
};
